<div class="filter-bar-wrapper">
  <app-filter-bar/>
</div>

<div class="dashboard-row">
  <!-- <mat-card class="chart-card chart-card--pie">
    <mat-card-header>
      <mat-card-title>{{ label() }} Statuses</mat-card-title>
      <mat-card-subtitle>
        {{ processor() }} &middot; {{ totalScans() | number }} scans
        @if (rangeLabel(); as r) {
          &middot; {{ r }}
        }
        @if (latestScanLabel(); as l) {
          &middot; Latest: {{ l }} ({{ timezone() }})
        }
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <div class="chart-container">
        <canvas
          baseChart
          [type]="pieChartType"
          [data]="pieChartData()"
          [options]="pieChartOptions">
        </canvas>
      </div>
    </mat-card-content>
  </mat-card> -->

  <mat-card class="chart-card chart-card--bar">

    <mat-toolbar class="chart-card-header-toolbar">
      <div class="right">
        <span class="chart-card-title">Activity by Date</span>
      </div>
      <div class="left">
        <button
          mat-raised-button
          color="primary"
          [disabled]="chartLoading || !data.activityByDateChartData().dates.length"
          (click)="exportChartCSV()">
          <mat-icon>download</mat-icon>
          Export to CSV
        </button>
      </div>
    </mat-toolbar>

    @if (chartLoading) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    <mat-card-content>

      @if (!chartLoading) {
        <div class="chart-container">
          <canvas
            baseChart
            [type]="stackedBarChartType"
            [data]="stackedBarChartData()"
            [options]="stackedBarChartOptions"
            [plugins]="chartPlugins">
          </canvas>
        </div>
      }

    </mat-card-content>

  </mat-card>

</div>

@if (auth.hasPermission('report.activity_by_date:Read')) {
<mat-card class="table-card">
  <mat-toolbar class="chart-card-header-toolbar">
    <div class="left">
      <span class="chart-card-title">Activity by Date Details</span>
    </div>
    <div class="right">
      <button mat-raised-button color="primary" [matTooltip]="csvDownloadHint" (click)="exportInvoiceReportCSV()">
        <mat-icon>download</mat-icon>
        Export to CSV
      </button>
      <!-- <button mat-raised-button color="primary" (click)="exportInvoiceReportCSV()">
        <mat-icon>download</mat-icon>
        Export Invoicing Report CSV
      </button> -->
    </div>
  </mat-toolbar>

  @if (tableLoading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <!-- <mat-form-field appearance="outline" subscriptSizing="dynamic" class="table-filter">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Search VIN, user, site, status…" />
  </mat-form-field> -->

  <div class="table-container">

    <div class="table-scroll">

      <table class="processed-vin-table" mat-table [dataSource]="data.newScans()">

        <!-- <ng-container matColumnDef="serialNumber">
          <th mat-header-cell *matHeaderCellDef mat-header>Sr. No.</th>
          <td mat-cell *matCellDef="let row">{{row.index}}</td>
        </ng-container> -->

        <ng-container matColumnDef="timestamp">
          <th mat-header-cell *matHeaderCellDef mat-header>
            <span class="table-header-span">Timestamp<mat-icon [matTooltip]="tableHeaderTooltips.timestamp">info_outline</mat-icon></span>
          </th>
          <td mat-cell *matCellDef="let row">{{formatDateTime(row.timestamp)}}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-header>
            <span class="table-header-span">Status<mat-icon [matTooltip]="tableHeaderTooltips.status">info_outline</mat-icon></span>
          </th>
          <td mat-cell *matCellDef="let row">
             @if (row.certificateLink != "" && row.certificateLink != null && row.certificateLink != undefined) {
              <!-- <a [href]="row.certificateLink" target="_blank" rel="noopener noreferrer">
                {{row.overAllStatus}}
              </a> -->
              <a [href]="row.certificateLink" target="_blank" rel="noopener noreferrer">
                <button mat-button>
                  <span>{{row.status}}</span>
                  <mat-icon iconPositionEnd>open_in_new</mat-icon>
                </button>
              </a>
            } @else {
              {{row.status}}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="vinCode">
          <th mat-header-cell *matHeaderCellDef mat-header>
            <span class="table-header-span">VIN Code<mat-icon [matTooltip]="tableHeaderTooltips.vinCode">info_outline</mat-icon></span>
          </th>
          <td mat-cell *matCellDef="let row">{{row.vinCode}}</td>
        </ng-container>

        <ng-container matColumnDef="decodedMake">
          <th mat-header-cell *matHeaderCellDef mat-header>
            <span class="table-header-span">Decoded Make<mat-icon [matTooltip]="tableHeaderTooltips.decodedMake">info_outline</mat-icon></span>
          </th>
          <td mat-cell *matCellDef="let row">{{row.decodedMake}}</td>
        </ng-container>

        <ng-container matColumnDef="decodedModel">
          <th mat-header-cell *matHeaderCellDef mat-header>
            <span class="table-header-span">Decoded Model<mat-icon [matTooltip]="tableHeaderTooltips.decodedModel">info_outline</mat-icon></span>
          </th>
          <td mat-cell *matCellDef="let row">{{row.decodedModel}}</td>
        </ng-container>

        <ng-container matColumnDef="decodedYear">
          <th mat-header-cell *matHeaderCellDef mat-header>
            <span class="table-header-span">Decoded Year<mat-icon [matTooltip]="tableHeaderTooltips.decodedYear">info_outline</mat-icon></span>
          </th>
          <td mat-cell *matCellDef="let row">{{row.decodedYear}}</td>
        </ng-container>

        <ng-container matColumnDef="processorSite">
          <th mat-header-cell *matHeaderCellDef mat-header>
            <span class="table-header-span">Processor Site<mat-icon [matTooltip]="tableHeaderTooltips.processorSite">info_outline</mat-icon></span>
          </th>
          <td mat-cell *matCellDef="let row">{{row.processorSite}}</td>
        </ng-container>

        <ng-container matColumnDef="username">
          <th mat-header-cell *matHeaderCellDef mat-header>
            <span class="table-header-span">User Name<mat-icon [matTooltip]="tableHeaderTooltips.username">info_outline</mat-icon></span>
          </th>
          <td mat-cell *matCellDef="let row">{{row.userName}}</td>
        </ng-container>

        <ng-container matColumnDef="emailId">
          <th mat-header-cell *matHeaderCellDef mat-header>
            <span class="table-header-span">Email ID<mat-icon [matTooltip]="tableHeaderTooltips.emailId">info_outline</mat-icon></span>
          </th>
          <td mat-cell *matCellDef="let row">{{row.emailID}}</td>
        </ng-container>

        <ng-container matColumnDef="inventorySyncStatus">
          <th mat-header-cell *matHeaderCellDef mat-header>
            <span class="table-header-span">Inventory Sync Status <mat-icon [matTooltip]="tableHeaderTooltips.inventorySyncStatus">info_outline</mat-icon></span>
          </th>
          <td mat-cell *matCellDef="let row">{{row.inventorySyncStatus}}</td>
        </ng-container>

        <ng-container matColumnDef="inventoryId">
          <th mat-header-cell *matHeaderCellDef mat-header>
            <span class="table-header-span">Inventory ID<mat-icon [matTooltip]="tableHeaderTooltips.inventoryId">info_outline</mat-icon></span>
          </th>
          <td mat-cell *matCellDef="let row">{{row.inventoryID}}</td>
        </ng-container>

        <ng-container matColumnDef="durationInSeconds">
          <th mat-header-cell *matHeaderCellDef mat-header>
            <span class="table-header-span">Duration in Seconds<mat-icon [matTooltip]="tableHeaderTooltips.durationInSeconds">info_outline</mat-icon></span>
          </th>
          <td mat-cell *matCellDef="let row">{{row.durationInSeconds}}</td>
        </ng-container>

        <ng-container matColumnDef="controllerId">
          <th mat-header-cell *matHeaderCellDef mat-header>
            <span class="table-header-span">Controller ID<mat-icon [matTooltip]="tableHeaderTooltips.controllerId">info_outline</mat-icon></span>
          </th>
          <td mat-cell *matCellDef="let row">{{row.controllerID}}</td>
        </ng-container>

        <!-- <ng-container matColumnDef="duration">
          <th mat-header-cell *matHeaderCellDef mat-header>Duration in Seconds</th>
          <td mat-cell *matCellDef="let row">{{row.durationInSeconds}}</td>
        </ng-container> -->

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <tr class="no-data-row" *matNoDataRow>
          <td [attr.colspan]="displayedColumns.length">No scans match the filter.</td>
        </tr>

      </table>

    </div>
    <!-- Disabled while loading: cursor pagination can't skip a page it hasn't
         fetched, so a second click before the first lands would desync the
         paginator from the rows. -->
    <mat-paginator [disabled]="tableLoading" [pageSize]="data.scanTablePagination().pageSize" [length]="data.scanTablePagination().total" (page)="paginatorEventHandler($event)"></mat-paginator>

  </div>

</mat-card>
}
